import Entity from './Entity';

import Area from './Area';

export default class Pref implements Entity {
  constructor(
    public id: number,
    public code: string,
    public name: string,
    public nameRuby: string,
    public createdAt: Date,
    public updatedAt: Date,
    public area: Area,
  ) {}
}
